<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="actionEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Action {{Copy.getTitle(Locale)}}
        <app-creator-modifier-icon style="float: right" [object]="Copy"></app-creator-modifier-icon></h2>
        <mat-dialog-content class="flex-grow-1" *ngIf="Copy" style="position: relative">
            <button type="button" mat-raised-button color="primary" style="position: absolute;  right: 25px; z-index: 100;" (click)="addBlock()">Add Row</button>
            <mat-tab-group class="button-tab">
                <mat-tab label="General">
                    <app-translation-field-editor [(List)]="Copy.Title"></app-translation-field-editor>
                    <div class="row">
                        <div class="col-md-12">
                          <mat-label>And/or operator?</mat-label>
                            <mat-form-field>
                                <mat-select name="Operator" [(ngModel)]="Copy.Operator">
                                    <mat-option value="and">AND</mat-option>
                                    <mat-option value="or">OR</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Start</mat-label>
                            <input name="StartDate" [ngModel]="Copy.StartDate | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.StartDate = $event" matInput type="datetime-local">
                          </mat-form-field>
                        </div>
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>End</mat-label>
                            <input name="EndDate" [ngModel]="Copy.EndDate | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.EndDate = $event"  matInput type="datetime-local">
                          </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Preview date</mat-label>
                            <input name="PreviewDate" [ngModel]="Copy.PreviewDate | date: 'yyyy-MM-dd\THH:mm'" (ngModelChange)="Copy.PreviewDate = $event"  matInput type="datetime-local">
                          </mat-form-field>
                        </div>
                        <div class="col-md-6">
                          <mat-form-field>
                            <mat-label>Delivery date</mat-label>
                            <input name="DeliveryDate"
                                   [ngModel]="Copy.DeliveryDate | date: 'yyyy-MM-dd\THH:mm'"
                                   (ngModelChange)="Copy.DeliveryDate = $event ? $event : null"
                                   matInput type="datetime-local">
                          </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Image</mat-label>
                                <input matInput name="GeneralImage" [(ngModel)]="Copy.Image">
                                <mat-hint>eg.: Articles/image-name.jpg</mat-hint>
                                <span matSuffix (click)="openPromotionAttachmentSelector()"><mat-icon>folder</mat-icon></span>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <app-group-selector multiple name="Groups" [(ngModel)]="Copy.Groups"></app-group-selector>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <app-dropdown-option [(ngModel)]="Copy.Type" discriminator="Type" model="Promotion"
                                                 name="Type" placeholder="Type"></app-dropdown-option>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-checkbox [(ngModel)]="Copy.IsSalesOnly" name="IsSalesOnly"> Sales Only</mat-checkbox>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab *ngFor="let block of Copy.Blocks; let last = last; let bi = index" label="{{block.OrderNumber}}. {{block.getTitle()}}">
                    <button type="button" mat-raised-button color="primary" style="position: absolute;  right: 0; z-index: 100;" (click)="addOption(block)">Add option</button>
                    <mat-tab-group>
                        <mat-tab label="Titles">
                            <app-translation-field-editor [(List)]="block.Title"></app-translation-field-editor>
                        </mat-tab>
                        <mat-tab label="Settings">
                            <div class="row">
                                <div class="col-md-4">
                                    <mat-form-field>
                                      <mat-label>Min. required QTY</mat-label>
                                        <input type="number" name="MinRequired{{block.randomNumber}}" [(ngModel)]="block.MinRequired" matInput>
                                        <mat-hint>Minimum needed in this row</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field>
                                      <mat-label>Max. required QTY</mat-label>
                                        <input type="number" name="MaxRequired{{block.randomNumber}}" [(ngModel)]="block.MaxRequired" matInput>
                                        <mat-hint>Maximum (in total) the client can order in this row</mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field>
                                      <mat-label>Step</mat-label>
                                        <input [(ngModel)]="block.StepRequired" matInput name="Step{{block.randomNumber}}" type="number">
                                        <mat-hint>How many are needed in this row to be valid</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab *ngFor="let option of block.Options; let i = index" [ngModelGroup]="option.randomNumber"
                                 label="{{option.OrderNumber}}. {{option.Title ? option.Title : 'Option'}} {{option.Title ? '' : i + 1}}">
                            <mat-card appearance="outlined" style="margin-bottom: 20px;">
                                <mat-card-title>General Settings</mat-card-title>
                                <mat-card-content>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                              <mat-label>Internal title</mat-label>
                                                <input name="OptionTitle{{option.randomNumber}}" [(ngModel)]="option.Title" matInput>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                              <mat-label>Image</mat-label>
                                                <input matInput name="Image{{option.randomNumber}}" [(ngModel)]="option.Image">
                                                <mat-hint>eg.: Articles/image-name.jpg</mat-hint>
                                                <span matSuffix (click)="openPromotionAttachmentSelector(bi, i)"><mat-icon>folder</mat-icon></span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <mat-form-field>
                                              <mat-label>Min. required QTY</mat-label>
                                                <input type="number" name="MinRequired{{option.randomNumber}}" [(ngModel)]="option.MinRequired" matInput required>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                              <mat-label>Max. required QTY</mat-label>
                                                <input type="number" name="MaxRequired{{option.randomNumber}}" [(ngModel)]="option.MaxRequired" matInput required>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                              <mat-label></mat-label>
                                                <input type="number" name="DefaultSelected{{option.randomNumber}}" [(ngModel)]="option.DefaultSelected" required matInput>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card-content>

                            </mat-card>
                            <mat-card appearance="outlined">
                                <mat-card-title>Content ({{option.BasketLines.length}})</mat-card-title>
                                <mat-card-content>
                                    <table class="mat-mdc-table">
                                        <tr>
                                            <th>Article</th>
                                            <th style="width: 125px;">UnitPrice</th>
                                            <th style="width: 125px;">Ordered</th>
                                            <th style="width: 125px;">Discount</th>
                                            <th style="width: 160px;">Discount Reason</th>
                                            <th class="text-right" style="width: 40px;">
                                                <button mat-icon-button [matMenuTriggerFor]="add" type="button">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                <mat-menu #add>
                                                    <button id="add-line" type="button" mat-menu-item (click)="addLine(option)">
                                                        Add Line
                                                    </button>
                                                    <button id="search-lines" type="button" mat-menu-item (click)="aEditor.open(option.BasketLines)">
                                                        Search Articles
                                                    </button>
                                                </mat-menu>
                                            </th>
                                        </tr>
                                        <tr *ngFor="let line of option.BasketLines" [ngModelGroup]="line.randomNumber">
                                            <td>
                                                <app-article-selector name="Article" [(ngModel)]="line.Article"></app-article-selector>
                                            </td>
                                            <td style="width: 125px;">
                                                <mat-form-field>
                                                  <mat-label>Unit price</mat-label>
                                                    <input name="UnitPrice" placeholder="UnitPrice" [(ngModel)]="line.UnitPrice" type="number" matInput>
                                                </mat-form-field>
                                            </td>
                                            <td style="width: 125px;">
                                                <mat-form-field>
                                                  <mat-label>Ordered</mat-label>
                                                    <input name="Ordered" [(ngModel)]="line.Ordered" type="number" matInput>
                                                </mat-form-field>
                                            </td>
                                            <td style="width: 125px;">
                                                <mat-form-field>
                                                  <mat-label>Discount</mat-label>
                                                    <input type="number" matInput name="Discount" [ngModel]="line.Discount * 100"
                                                           (ngModelChange)="line.Discount = $event / 100; ($event === 0 || $event === null) ? line.DiscountReason = null : false;"
                                                           required>
                                                    <span matSuffix>%</span>
                                                </mat-form-field>
                                            </td>
                                            <td style="width: 160px;">
                                              <app-dropdown-option [(ngModel)]="line.DiscountReason" [required]="line.Discount > 0" name="Discountreason" placeholder="Discount Reason"
                                                                   model="DocumentLine" discriminator="DiscountReason"></app-dropdown-option>
                                            </td>
                                            <td style="width: 40px;">
                                                <button type="button" mat-icon-button appConfirmDialog (confirm)="removeLine(option, line)">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            <div class="row" style="margin-top: 15px;">
                                <div class="col-12">
                                    <button type="button" mat-raised-button color="warn" appConfirmDialog (confirm)="removeOption(block, option)">Delete this option</button>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-12">
                            <button type="button" mat-raised-button color="warn" appConfirmDialog (confirm)="removeBlock(block)">Delete this block</button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Preview">
                    <div class="row" style="margin-top: 20px;" *ngFor="let block of Copy.Blocks">
                        <div class="col-sm-12">
                            <mat-card appearance="outlined">
                                <mat-card-title>{{block.getTitle()}}</mat-card-title>
                            </mat-card>
                        </div>
                        <div *ngFor="let option of block.Options; let i = index" class="col-sm-2" style="margin-top: 20px;">
                            <mat-card appearance="outlined">
                                <mat-card-content>
                                    <div class="row" *ngFor="let line of option.BasketLines">
                                        <div class="col-sm-12">
                                            <img src="{{line.Article?.getImage()}}" style="max-height: 125px;">
                                        </div>
                                        <div class="col-sm-12">
                                          {{line.Ordered}}x {{line.Article?.DisplayName}} {{line.Article?.Step}}x {{line.Article?.OptionWeight}}{{line.Article?.Unit?.Value}}
                                        </div>
                                        <div class="col-sm-12">
                                            € {{line.UnitPrice ? line.UnitPrice : 'Customer\'s Price'}} - {{line.Discount * 100}}%
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Order">
                    <div *ngFor="let block of Copy.Blocks; let i = index;" class="row order-row">
                        <div class="col-sm-1">
                            <button (click)="updateOrder()" color="primary" mat-button mat-raised-button type="button">Update</button>
                        </div>
                        <div class="col-sm-2">
                            <mat-form-field style="width: 25px;"><mat-label>Block order number</mat-label><input [(ngModel)]="block.OrderNumber" matInput name="block{{i}}"></mat-form-field>
                            {{block.getTitle()}}

                        </div>
                        <div class="col-sm-9">
                            <ng-container *ngIf="block.Options.length > 0">
                                <div *ngFor="let option of block.Options; let x = index;" class="row order-row">

                                    <div class="col-sm-6">
                                        <mat-form-field style="width: 25px;"><mat-label>Option order number</mat-label><input [(ngModel)]="option.OrderNumber" matInput name="option{{i}}{{x}}"></mat-form-field>
                                        {{option.Title}}
                                    </div>

                                    <div class="col-sm-6">
                                        <ng-container *ngIf="option.BasketLines.length > 0">
                                            <div *ngFor="let line of option.BasketLines; let y = index;" class="row order-row">
                                              <div class="col-sm-12">
                                                <mat-form-field style="width: 25px;"><mat-label>Basket line order number</mat-label><input [(ngModel)]="line.OrderNumber" matInput name="line{{i}}{{x}}{{y}}"></mat-form-field>
                                                {{line.Article?.Code}} - {{line.Article?.DisplayName}}
                                              </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions class="d-flex">
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>

<app-visual-article-picker #aEditor [ShoppingCart]="false"></app-visual-article-picker>
